module.exports = __webpack_public_path__ + "img/j4.c8117c36.png";